import { READ } from '@wix/wix-data-client-common-standalone';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_BEFORE_IMPROVEMENT, } from './pagination';
export const defaultDatasetConfiguration = {
    collectionName: null,
    readWriteType: READ,
    filter: null,
    sort: null,
    includes: null,
    nested: [],
    pageSize: DEFAULT_PAGE_SIZE,
    deferred: false,
};
export const getDefaultPageSize = ({ maxPageSize, isSinglesCollection = false, numberOfItemsImprovementsOpen = false, }) => {
    const defaultPageSize = numberOfItemsImprovementsOpen
        ? DEFAULT_PAGE_SIZE
        : DEFAULT_PAGE_SIZE_BEFORE_IMPROVEMENT;
    return isSinglesCollection
        ? 1
        : maxPageSize
            ? Math.min(maxPageSize, defaultPageSize)
            : defaultPageSize;
};
//# sourceMappingURL=defaults.js.map